import styled from '@emotion/styled';
import { StyledProps } from './TableRowContainer.types';

export const borderColor = 'var(--color-indigo-t3)';

export default styled.tr<StyledProps>`
  list-style-type: none;
  background-color: ${(props) => props.primaryColor || 'var(--color-extra-white)'};
  color: ${(props) => props.color || 'var(--color-indigo-t11)'};

  &:nth-of-type(2n + 1) {
    border: 1px ${borderColor};
    border-style: solid;
  }

  &:nth-of-type(2n) {
    background-color: ${(props) => props.secondaryColor || 'var(--color-b0)'};
    border: 1px ${borderColor};
    border-style: solid;
  }

  &:hover {
    background-color: ${(props) => props.rowClickable && 'var(--color-vibrant-blue-t0)'};
  }
`;
